<template>
  <div :class="$style['pt-lab-order-detail']" v-if="order" v-loading="loading">
    <pt-page-title title="样品详情"></pt-page-title>
    <pt-sub-title title="样品状态">
      <span slot="line" style="color:red;margin-left:10px;" v-if="order && showWarning && order.product">{{warningInfo}}</span>
      <pt-legend :statusArray="statusArray"></pt-legend>
    </pt-sub-title>
    <!-- 步骤条 -->
    <pt-lab-order-progress :class="$style['order_progress']" :order-status="statuses" :task="task" :order-detail="order" :tasks="tasks"></pt-lab-order-progress>
    <div v-if="showTaskreason" :class="$style['task-reason']">异常原因：{{taskReason}}</div>
    <!-- 状态操作需补充 -->
    <p v-if="notNeedOperate" style="height:20px;"></p>
    <template v-else>
      <template v-if="order">
        <order-status :class="showTaskreason?'order-status-form-reason':''" :order-detail="order" :task="task" :status="nextStatus" :order="order" v-if="!this.$route.params.approval" @status-change="reload" :order-status="statuses" @isLoading="isLoading" :hideForm="this.orderflowHelper.canNotOperation(this.nextStatus,this.order)">
        </order-status>
        <p v-else style="height:10px;"></p>
      </template>
    </template>
    <!-- <el-button @click="showReport=true" size="small" type="primary">查看报告</el-button> -->
    <!-- 样本信息 -->
    <pt-sub-title title="异常提示" v-if="abnormalData.length || msg"></pt-sub-title>
    <p style="margin:.5rem .2rem;color:#F56C6C">{{msg}}</p>
    <el-table :data="abnormalData" :span-method="objectSpanMethod" style="width: 95%; margin: 50px" v-if="abnormalData.length">
      <el-table-column prop="rsId" label="位点编号" width="230" height="30">
      </el-table-column>
      <el-table-column prop="call" label="检测结果" width="200">
      </el-table-column>
      <el-table-column prop="detectionPackage" label="套餐名称" width="380">
      </el-table-column>
      <el-table-column prop="assayId" label="Assay ID" width="200">
      </el-table-column>
      <el-table-column prop="" label="异常提示">
        <template slot-scope="scope">
          <p style="color:#F56C6C"> {{ scope.row.errMsg }}</p>
        </template>
      </el-table-column>
    </el-table>
    <pt-sub-title title="样品信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p>
          <span>样品编号：</span>
          {{order.orderCode}}
        </p>
        <p>
          <span>客户标识：</span>
          {{order.customerCode}}
        </p>
        <p>
          <span>实验室唯一码：</span>
          {{order.labCode}}
        </p>
        <p>
          <span>检测项目：</span>
          {{order.labExamItem.itemName}}
        </p>
        <p>
          <span>检测依据：</span>
          {{order.labExamItem.examBasis&&order.labExamItem.examBasis.name}}
        </p>
				<div :class="$style.attachments">
					<span>检测相关文献：</span>
					<div :class="$style['attachments-list']">
					<div v-for="(item,i) in order.labExamItem.attachments" :key="i">
						<a style="margin-right:20px;vertical-align:middle;" :href="$privateResourcesUrl+item.ossUrl" target="_blank" :class="$style.special">{{item.name}}</a>
					</div>
				</div>
				</div>
        <p>
          <span>是否偏离：</span>
          {{order.labExamItem&&(order.labExamItem.deviate?'是':'否')}}
        </p>
        <p>
          <span>偏离原因：</span>
          {{order.labExamItem&&order.labExamItem.deviateInfo}}
        </p>
        <p>
          <span>样品名称：</span>
          {{order.orderName}}
        </p>

        <p>
          <span>颜色：</span>
          {{order.color_text || '--'}}
        </p>

      </wt-box>
      <wt-box :class="$style['order-info']">
        <p>
          <span>交付方式：</span>
          {{order.delivery_type  || '--'}}
        </p> 
				<p>
          <span>形态：</span>
          {{order.shape_text  || '--'}}
        </p>
        <p>
          <span>包装：</span>
          {{order.pack_text  || '--'}}
        </p>
        <p>
          <span>生产单位：</span>
          {{order.productionUnit  || '--'}}
        </p>
        <p>
          <span>生产日期：</span>
          {{order.orderProductDate  || '--'}}
        </p>
        <p>
          <span>生产批号：</span>
          {{order.productBatchCode  || '--'}}
        </p>
        <p>
          <span>商标：</span>
          {{order.brand || '--'}}
        </p>
        <p>
          <span>规格/型号：</span>
          {{order.specificationModel_text || '--'}}
        </p>
        <p>
          <span>数量：</span>
          {{order.orderCount}}
        </p>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <p>
          <span>存放条件：</span>
          {{order.storage_text}}
        </p>
        <p>
          <span>检测次数：</span>
          {{order.testTimes}}
        </p>
      </wt-box>
    </wt-grid>
    <!-- 附件信息 -->
    <template v-if="order && order.attachments&&order.attachments.length">
      <pt-sub-title title="相关文献"></pt-sub-title>
      <div :class="$style['order-info-file__list']" v-if="LITERATURE_attachments">
        <template v-for="(item,index) in LITERATURE_attachments">
          <a class="item-line" :key="index" :href="$privateResourcesUrl+item.ossUrl.replace(/\+/g, '%2B')" target="_blank" v-if="item&&item.ossUrl">{{item.name}}</a>
        </template>
      </div>

      <el-button style="margin-left:20px" type="primary" @click="exportRawData" v-if="isComplete && isAttachmentsShow">导出下机数据</el-button>
    </template>
    <!-- 实验人员 -->
    <pt-sub-title title="实验人员"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p>
          <span>创建样品人员：</span>
          {{order.otherInfo.orderCreatedUser || '--'}}
        </p>
        <p>
          <span>接收样品人员：</span>
          {{order.otherInfo.orderReceivedUser || '--'}}
        </p>
        <p>
          <span>任务分派人员：</span>
          {{order.otherInfo.orderAssignUser || '--'}}
        </p>
        <p>
          <span>领取样品人员：</span>
          {{order.otherInfo.orderGetUser || '--'}}
        </p>
        <p>
          <span>检测实验人员：</span>
          {{order.otherInfo.orderExamUser || '--'}}
        </p>
        <p>
          <span>接收数据人员：</span>
          {{order.otherInfo.orderDataReceivedUser || '--'}}
        </p>
        <p>
          <span>编制报告人员：</span>
          {{order.otherInfo.orderReportCreatedUser || '--'}}
        </p>
        <p>
          <span>审核报告人员：</span>
          {{order.otherInfo.orderReportCheckUser || '--'}}
        </p>
        <p>
          <span>归还样品人员：</span>
          {{order.otherInfo.orderBackUser || '--'}}
        </p>
        <p>
          <span>回收样品人员：</span>
          {{order.otherInfo.orderRecoveryUser || '--'}}
        </p>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_created_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_received_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_assign_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_get_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_exam_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_data_received_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_report_created_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_report_check_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_back_date || '--'}}
        </p>
        <p>
          <span>日期：</span>
          {{order.otherInfo.order_recovery_date  || '--'}}
        </p>
      </wt-box>
    </wt-grid>
    <!-- 订单信息 -->
    <pt-sub-title title="所属委托单信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']" v-if="order">
      <wt-box :class="$style['order-info']">
        <p>
          <span>委托单编号：</span>
          {{order.billCode}}
        </p>
        <p>
          <span>是否加急：</span>
          <el-tag type="danger" size="small" v-if="order.urgent">加急</el-tag>
          <template v-else>否</template>
        </p>
        <p>
          <span>是否返还：</span>
          {{order.back_text}}
        </p>
        <p>
          <span>预计交付日期：</span>
          {{order.delivery_date}}
        </p>
      </wt-box>
    </wt-grid>

    <el-button type="primary" v-if="order && !isClosed" @click="goEdit(order.id)">编辑样品</el-button>
    <!-- <template v-if="isComplete">
      <el-button v-if="order.settled" type="primary" size="small" @click="handleSettle(false)">取消结算</el-button>
      <el-button v-else type="primary" size="small" @click="handleSettle(true)">结算</el-button>
    </template> -->
    <!-- <el-button type="primary" v-if="isComplete" size="small" @click="handleSettle(order.id)">结算</el-button> -->
    <!-- <el-button type="danger" v-if="HAS_PERM_LAB_DELETE_ORDER" size="small" @click="toDelete(order.id)">删除订单</el-button> -->
    <el-button type="danger" @click="toClose(order.id)" v-if="!isClosed">关闭样品</el-button>
    <lab-order-dialog :dialogInfo="dialogInfo" @close="closeDialog" @loading="onLoading" @refresh="reload">
    </lab-order-dialog>
  </div>
</template>

<script>
// 组件class前缀
import ptLegend from 'cps/base/pt-legend'
import ptLabOrderProgress from './pt-lab-order-progress'
import {
  genderFormat,
  formatDate,
  formatDateObject,
  birthdayToAge,
  getReportSignature,
  ToAge
} from '@/utils/formUtils'
import orderflowHelper from '@/config/order'
import orderStatus from 'cps/lab-order/order-status'
import {
  formatOperationLog
} from 'enumeration/lab-order.js'
import {
  certificatesTypeMap
} from 'json/lab-order'
import {
  sampleType, ucasSampleType
} from 'json/goods-order-options'
import {
  getEnumeration
} from 'enumeration'
import {
  hasPermissions
} from 'utils/permissions'
import {
  getDayTypes
} from 'enumeration/mall.js'
import {
  formResult
} from 'enumeration/lab-order'
import labOrderDialog from 'cps/lab-order/pt-lab-order-dialog'
const prefixCls = 'pt-lab-order-detail'
const PERM_LAB_EDIT_ORDER = 'PERM_LAB_EDIT_ORDER'
const PERM_LAB_DELETE_ORDER = 'PERM_LAB_DELETE_ORDER'
// const PERM_STATUS_MAP = {
//   'LAB_SAMPLES_RECEIVED': 'PERM_LAB_SAMPLE_RECEIVE',
//   'LAB_DNA_READY': 'PERM_LAB_DNA_READY',
//   'DATA_ANALYSISED': 'PERM_LAB_DATA_ANALYSISED',
//   'REPORT_CHECKED_1ST': 'PERM_LAB_CHECKED_1ST'
// }
export default {
  name: 'pt-lab-order-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    LITERATURE_attachments () {
      return this.order?.attachments?.filter(e => e.type === 'LITERATURE') || []
    },
    SampleReceiveTime () {
      return formatDate(this.order?.otherInfo?.SampleReceiveTime)
    },
    isClosed () {
      return this.order && this.order.orderStatusEnum === 'CLOSED'
    },
    isComplete () {
      return this.order && this.order.nextOrderAction === 'NONE'
      // if (this.statuses[this.statuses.length - 1]) {
      //   return (
      //     false
      //   //   this.statuses[this.statuses.length - 1].orderStatus === 'COMPLETED'
      //   )
      // }
      // return false
    },
    //不需要操作的节点
    notNeedOperate () {
      return this.isComplete||this.isClosed||this.nextStatus==='ORDER_RECEIVED'
    },
    nextStatus () {
      return this.order?.nextOrderAction
    },
    resultUrl () {
      return '/show-calculate-result/' + this.order.reportJobId
    },
    HAS_PERM_LAB_EDIT_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_LAB_EDIT_ORDER)
    },
    HAS_PERM_LAB_DELETE_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions,
        PERM_LAB_DELETE_ORDER)
    },
    showWarning () {
      let status = orderflowHelper.formatOrderActions(this.order.nextOrderAction)
      return this.order.remainingDays !== null && this.order.remainingDays <= 3 && status !== '已完成' && this.order
        .orderStatusEnum !== 'CLOSED'
    },
    warningInfo () {
      return `预计交付日期${formatDate(this.order.expectedDeliveryDate)}，剩余${this.order.product.dayType ? getDayTypes(this.order.product.dayType) : ''}${this.order.remainingDays}`
    },
    isTarget () {
      return this.$store.state.saasConfig.openContract ? '_blank' : '_self'
    },
    dnaSampleInformation () {
      return this.order.currentSample.dnaSampleInformation
    },
    orderDetail () {
      let statusflow = this.statuses.filter(e => e.action !== 'CREATE' && e.action !== 'CHIP_SLOT' && e.action !== 'HYBRIDIZATION')
      let list = statusflow.map(item => {
        let {
          reason,
          comment
        } = item
        let obj = {
          status: orderflowHelper.formatTargetOrderStatus(item.action),
          result: this.formResult(item.orderStatusResult),
          reason,
          comment
        }
        return obj
      })
      let orderInfoShow = [...list]
      if (this.task) {
        let data = this.task && this.task.orderActionData && this.task.orderActionData.statusDetail
        if (data) {
          let {
            reason,
            comment
          } = data
          orderInfoShow.push({
            status: orderflowHelper.formatTargetOrderStatus(data.action),
            result: this.formResult(data.orderStatusResult),
            reason,
            comment
          })
        }
      }
      console.log('orderInfoShow========================', orderInfoShow)
      return orderInfoShow || []
    },
    focusView () {
      return this.$store.state.saasConfig.focusView
    },
    isContractFunction () {
      return this.$store.state.saasConfig.openContract
    },
    pictureOssList () {
      return this.order.attachments
    },
    isAttachmentsShow () {
      return this.order.attachments.find(res => {
        return res.type === 'RAW_DATA'
      })
    },
    showTaskreason () {
      return this.tasks && this.tasks.length
    },
    taskReason () {
      let reason = ''
      this.tasks.forEach(item => {
        reason = reason ? (reason + ';' + item.reason) : item.reason
      })
      return reason
    }
    // disabled () {
    //   return this.order && this.order.nextOrderAction !== 'LAB_SAMPLES_RECEIVED'
    // }
  },
  props: {
    statuses: {
      type: Array,
      default: () => []
    },
    task: {
      type: Object
    },
    signatureManagement: {
      type: Object
    },
    order: {
      type: Object,
      default: () => { }
    },
    tasks: {
      type: Array,
      default: () => []
    },
    logs: {
      type: Array,
      default: () => []
    },
    samplePlates: {
      type: Array,
      default: () => []
    },
    sampleRecollectLogs: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    task: {
      handler (val) {
        if (val && val.jobErrorMsg) {
          for (let i = 0; i < val.jobErrorMsg.length; i++) {
            this.msg += val.jobErrorMsg[i]
          }
        }
        this.abnormalData = this.changeTask(val)
      },
      deep: true
    }

  },
  data () {
    return {
      logTableLabels: [{
        label: '操作时间',
        value: 'operationTime'
      },
      {
        label: '操作步骤',
        value: 'orderAction'
      },
      {
        label: '操作人员',
        value: 'auditInformation.operatorName'
      },
      {
        label: '操作',
        value: 'operationLog'
      },
      {
        label: '原因',
        value: 'reason'
      },
      {
        label: '备注',
        value: 'comment'
      }
      ],
      abnormalData: [],
      certificatesTypeMap: certificatesTypeMap,
      sampleType: sampleType,
      ucasSampleType: ucasSampleType,
      showReport: false,
      orderflowHelper: orderflowHelper,
      statusArray: [{
        color: '#409eff',
        text: '已操作'
      },
      {
        color: '#f69b07',
        text: '异常待处理'
      },
      {
        color: '#f56c6c',
        text: '异常'
      },
      {
        color: '#5FABF2',
        text: '待操作'
      }
      ],
      dialogInfo: {},
      loading: false,
      customerSignature: [],
      msg: '',
      signatureInfo: [],
      previewVisible: false,
      currentIndex: 0,
      images: []
    }
  },
  components: {
    ptLegend,
    ptLabOrderProgress,
    orderStatus,
    labOrderDialog
  },
  methods: {
    download (val) {
      location.href = `${this.$privateResourcesUrl}/${val.ossUrl.replace(/\+/g, '%2B')}`
    },
    picFindObj (val) {
      return val.action === 'LAB_SAMPLES_RECEIVED' && val?.attachmentFileInformationList?.length
    },
    changeData (val) {
      val.reportSignature = val.reportSignature || val.re ? '有' : '无'
      if (val.signatures[0]) {
        val.reportSignatureOne = getReportSignature(val.signatures[0].signature, val.signatures[0].name)
      }
      if (val.signatures[1]) {
        val.reportSignatureTwo = getReportSignature(val.signatures[1].signature, val.signatures[1].name)
      }
      if (val.signatures[2]) {
        val.reportSignatureThree = getReportSignature(val.signatures[2].signature, val.signatures[2].name)
      }
      // let newVal = []
      // newVal.push(val)
      return val
    },
    genderFormat,
    formatDate,
    formatDateObject,
    formatOperationLog,
    getEnumeration,
    birthdayToAge,
    ToAge,
    formResult,
    changeTask (Data) {
      let array = Data ? Data.orderActionData.lociToCheckMap : []
      let newArray = []
      for (var i in array) {
        array[i][0].index = array[i].length
        newArray = newArray.concat(array[i])
      }
      return newArray
    },
    onPreview (index) {
      this.images = []
      this.pictureOssList.forEach(item => {
        this.images.push(this.$privateResourcesUrl + item.ossUrl)
      })
      this.previewVisible = true
      this.currentIndex = index
    },
    closePreview () {
      this.previewVisible = false
    },
    reload () {
      console.log('---------reload')
      this.$emit('on-reload')
      // this.load()
      // this.loadOrderStatus()
    },
    isLoading (val) {
      this.$emit('handle-loding', val)
      // this.loading = val
    },
    getFileName (fileUrl) {
      let arr = fileUrl.split('/')
      return arr[arr.length - 1]
    },
    goEdit (id) {
      this.$router.push(`/lab-order-form/true/${id}`)
    },
    // 判断各个状态的权限
    // hasPermissionOpr (status) {
    //   let isSupport = Object.keys(PERM_STATUS_MAP).includes(status)
    //   if (!isSupport) {
    //     return true
    //   }
    //   return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_STATUS_MAP[status])
    // }
    toDelete (id) {
      this.$confirm('点击“确定”，将永久删除本订单并不能恢复，请谨慎操作。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('handle-loding', true)
        this.$store.dispatch('deleteLabOrder', id).then((response) => {
          this.$emit('handle-loding', false)
          this.reload()
          // this.$message.success('请在“异常订单”页面确认删除订单')
          // history.go(-1)
        }).catch((error) => {
          this.$emit('handle-loding', false)
          console.error(error)
          this.$message.error(error + '删除订单失败！')
        })
      })
    },
    toUpdateData (id) {
      this.dialogInfo = {
        type: 1,
        visible: true,
        title: '重传数据',
        desc: '订单将返回至上传数据状态',
        id: id
      }
    },
    toClose (id) {
      this.dialogInfo = {
        type: 3,
        visible: true,
        title: '关闭订单',
        desc: '订单将关闭',
        id: id
      }
    },
    closeDialog () {
      this.dialogInfo.visible = false
    },
    objectSpanMethod ({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex === 0) {
        if (row.index) {
          return {
            rowspan: row.index,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    onLoading (isSubmit) {
      this.loading = isSubmit
    },
    handleSettle (toggle) {
      let info = toggle ? '结算' : '取消结算'
      this.$confirm('此操作将' + info + '此订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onLoading(true)
        let data = {
          orderIds: [this.order.id],
          result: toggle
        }
        this.$store.dispatch('handleSettle', data).then(res => {
          this.onLoading(false)
          this.$message.success('操作成功')
          this.reload()
        }).catch(err => {
          this.onLoading(false)
          this.$message.warning('操作失败' + err)
        })
      })
    },
    exportRawData () {
      let params = {
        'needActionTaskInfo': true,
        'pageableParam': {
          'page': 0,
          'size': 50,
          'sort': ['createdTime,desc']
        },
        'statusTime': [{
          'startTime': '',
          'endTime': '',
          'orderStatus': 'COMPLETED'
        }, {
          'startTime': null,
          'endTime': null
        }],
        'needHistoryOrders': true,
        'ids': [this.order.id]
      }
      this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        this.$store.dispatch('downloadRawData', params).then(message => {
          // dataExport(res)
          this.$message.success(message)
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$message(err || '导出失败')
        })
      })
    }
  }
}

</script>

<style module lang="less">
@import "~less/var.less";

/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.order-message-id {
  padding: 0 0 0 10px;

  span {
    color: #409eff !important;
  }
}

.special{
  color:@mainColor;
  text-decoration: none;
}
.attachments{
	display: flex;
  span {
    color: #409eff !important;
  }
}
.attachments-list{
	display: block;
}
.pt-lab-order-detail {
  :global .el-radio {
    & + .el-radio {
      margin-left: 30px;
    }
  }
  :global {
		.order-status-form-reason{
			padding:0.2rem
		}
    .item-line {
      // line-height: 30px;
      color: #409eff;
      text-decoration: underline;
    }
  }
  :global .el-button + .el-button {
    margin-left: 0.3rem;
  }

  // :global .el-table td {
  //   padding: 0 !important
  // }
}

.order-info__box {
  padding: 10px 20px;
}
.order-info-file__list {
  display: flex;
  padding: 10px 20px;
  :global {
    a {
      margin-left: 10px;
    }
    div {
      a {
        padding: 10px 0;
        display: block;
      }
    }
  }
}
.order-info {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color:#6D6D6D;

  > p >span:not(:global .el-tag) {
    font-size: 14px;
    color: @mainColor;
    line-height: 30px;
  }
}

.order-info > div {
  span {
    display: block;
  }
}

.order_progress {
  margin-top: 30px;
}

.special-operate {
  display: block;

  span {
    margin-right: 30px;
    color: #666;
    line-height: 30px;
  }
}

.maincolor {
  color: #409eff !important;
  display: inline-block;
  margin: 0 10px !important;
}

.specialColor {
  color: #409eff !important;
}

.aColor {
  color: #409eff !important;
  margin-left: 10px;
  text-decoration: none;
}

.package-table-div {
  margin-top: 10px;
  padding: 10px 20px 30px;
  max-width: 1800px;
}

.package-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse !important;

  th,
  tr {
    width: 100% !important;
    max-width: 100% !important;
    display: table-row;
    padding: 0 !important;
    list-style-type: none;
    border-bottom: 1px solid #c6c9d3;
    color: #818181;
  }

  td {
    text-align: center;
    padding: 0.1rem 0;
  }
}
.task-reason{
	padding: 20px 20px 0;
	font-size: .16rem
}
</style>
